
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Footer from './Components/Footer/Footer';
import Navbar from './Components/Navbar/Navbar';
import Homepage from './Pages/Homepage/Homepage';




import { Box } from "@chakra-ui/react"
import Login from './Pages/LoginSignup/Login';
import Signup from './Pages/LoginSignup/Signup';
// import { useSelector } from 'react-redux';
import Rent from './Components/Rent_Page/rent';
import { Yourinput } from './Components/Rent_Page/components/Input';
import Payment from './Components/Payment_Detail/payment';
import ToPayment from './Components/Card_Detail_Page/payment';
import AboutUs from './Pages/Static/AboutUs';
import ContactUs from './Pages/Static/ContactUs';
import PrivacyPolicy from './Pages/Static/PrivacyPolicy';
import TermsAndConditions from './Pages/Static/TermsAndConditions';
import ShippingPolicy from './Pages/Static/ShippingPolicy';
import RefundPolicy from './Pages/Static/RefundPolicy';
import ScrollToTop from './Components/ScrollToTop.js';

function App() {
  // const { loginReq } = useSelector((state) => state)
  return (
    <Box>
<ScrollToTop/>

      <Navbar />

      <Routes>

        <Route path="/" element={<Homepage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
<Route path="/privacy-policy" element={<PrivacyPolicy />} />
<Route path="/terms-and-conditions" element={<TermsAndConditions />} />
<Route path="/shipping-policy" element={<ShippingPolicy />} />
<Route path="/refund-policy" element={<RefundPolicy />} />
        {/* <Route path="/payrent/*" element={<Rent />} /> */}
        <Route path="/payrent/houserent" element={<Rent />} />
        <Route path='/payrent/paymentdetail' element={<Payment />}></Route>
        <Route path="/payrent/payment" element={<ToPayment />}></Route>
      </Routes>

      <Footer />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
      </Routes>
    </Box>
  );
}

export default App;
